/**
 * Valeur retardée — **le débounce de 400 ms exigé par le §5.2**.
 *
 * ⚠️ Ce n'est pas un confort d'interface : chaque frappe non retardée serait un
 * appel réseau vers Open Food Facts, et le §5.2 impose « requêtes séquentielles,
 * jamais en rafale ». Le serveur tient la cadence de son côté (file séquentielle
 * dans `services/off.ts`), mais c'est ici qu'on évite de la remplir pour rien :
 * « poulet » tapé au clavier vaut 6 requêtes sans débounce, 1 avec.
 *
 * La valeur *affichée* dans le champ, elle, n'est jamais retardée — c'est la
 * requête qui l'est. Sans quoi la saisie donnerait l'impression de coller.
 */

import { useEffect, useState } from 'react';

/** Délai imposé par l'architecture (§5.2). Ne pas réduire « pour la réactivité ». */
export const SEARCH_DEBOUNCE_MS = 400;

export function useDebouncedValue<T>(value: T, delayMs = SEARCH_DEBOUNCE_MS): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
}
